import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import EngineeringIcon from "@mui/icons-material/Engineering";
import { styled } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import { useLocaleFormatters } from "../../../../hooks/useLocaleFormatters";
import type { MaintenanceWindow } from "./useMaintenanceWindow";

export interface MaintenanceScreenProps {
  window: MaintenanceWindow;
}

const MaintenanceLayout = styled(Stack)({
  alignItems: "center",
  justifyContent: "center",
  minHeight: "100vh",
  textAlign: "center",
  padding: "32px",
});

const MaintenanceIcon = styled(EngineeringIcon)(({ theme }) => ({
  fontSize: 64,
  color: theme.palette.text.secondary,
}));

const MaintenanceDescription = styled(Typography)({
  maxWidth: 480,
});

/** Full-page maintenance screen. Render when useMaintenanceWindow returns a window. */
export function MaintenanceScreen({ window: w }: MaintenanceScreenProps) {
  const { t } = useTranslation();
  const { formatEndTime } = useLocaleFormatters();
  return (
    <MaintenanceLayout gap={2}>
      <MaintenanceIcon />
      <Typography variant="h5">{w.title ?? t("maintenance.defaultTitle")}</Typography>
      <MaintenanceDescription variant="body1" color="text.secondary">
        {w.description ?? t("maintenance.defaultDescription")}
      </MaintenanceDescription>
      <Typography variant="body2" color="text.secondary">
        {t("maintenance.expectedBack", { time: formatEndTime(w.end) })}
      </Typography>
    </MaintenanceLayout>
  );
}
